module.exports = __webpack_public_path__ + "media/target_area_icon/dept_helpdesk-3333a957.png";